import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';

export class DSALevelTypeColumn extends ProjectionGridBaseColumn {
  constructor({ newI18n }) {
    const title = newI18n.getString(_TL_('Type'));

    super({
      name: 'DSALevelType',
      property: 'DSALevelType',
      title,
      bodyClasses: ['grid-column-dsaLevelType'],
      colClasses: ['col-longText'],
      sortable: false,
      type: 'string',
    });
    this.newI18n = newI18n;
  }

  template({
    value: {
      Target: { CampaignId },
    },
  }) {
    return _.isNull(CampaignId) ?
      this.newI18n.getString(_TL_('New campaign')) :
      this.newI18n.getString(_TL_('New dynamic ad group'));
  }

  get property() {
    return {
      get: item => _.first(item.Opportunities),
    };
  }
}
